import React from 'react';
import useAppStore from '../../store/useAppStore.js';
import './WatchlistHeader.css';

export default function WatchlistHeader() {
  const { sortColumn, sortDirection, setSort } = useAppStore();

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return null;
    return sortDirection === 'asc' ? ' ▲' : ' ▼';
  };

  return (
    <div className="watchlist-header">
      <div className="watchlist-header-cell" onClick={() => setSort('ticker')}>
        Symbol{renderSortIcon('ticker')}
      </div>
      <div className="watchlist-header-cell" onClick={() => setSort('price')}>
        Last{renderSortIcon('price')}
      </div>
      <div className="watchlist-header-cell" onClick={() => setSort('change')}>
        Chg{renderSortIcon('change')}
      </div>
      <div className="watchlist-header-cell" onClick={() => setSort('change_pct')}>
        Chg %{renderSortIcon('change_pct')}
      </div>
      <div className="watchlist-header-cell">
        Signals
      </div>
    </div>
  );
}
